import React, {useMemo, useEffect, useState} from 'react';
import S from 'StyledDepositLogin.js';
import {translation} from 'helpers/utilsHelper.js';
import {withRouter} from 'react-router-dom';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _omit from 'lodash/omit';
import ProviderContent from 'ProviderContent.js';
import paymentPrepareTransaction from 'paymentPrepareTransaction.enum.js';

const DepositLogin = ({user, paymentProviders, toggleModal, toggleAccountModal, history}) => {

    const isLogged = (user !== undefined);
    const DEFAULT_PROVIDER_ID = 103;
    const {LIST_SETTINGS:{miniature, visalbleDepositsIfNotLogged}, PROVIDER} = paymentPrepareTransaction;
    const paymentData = paymentProviders;
    const controller = app.getCurrentController();

    const openAccountModal = () => {
         toggleModal();
         history.push('/deposit');
         toggleAccountModal();
    }

    if (!isLogged && controller != 'AgentDeposit' && !visalbleDepositsIfNotLogged /*&& !isPending*/) {
      return (<NotLogged>{translation('payment_notLogged')}</NotLogged>);
    }

    if (paymentData.length){
      const provider = paymentData.find((p)=> p.providerId == DEFAULT_PROVIDER_ID );
      return (
        <S.AccountDeposit onlyOne={true}>
            <S.Row><S.Header>{translation('account_loggedPanel_depositLoginPopup_loginText')}{user.login}</S.Header></S.Row>
            <S.Row><S.Text>{translation('account_loggedPanel_depositLoginPopup_mainText')}</S.Text></S.Row>
            <S.Row><S.Text>{translation('account_loggedPanel_depositLoginPopup_balance')}:
                <S.Balance>{user.balance}</S.Balance><S.Currency>{user.currencyCode}</S.Currency>
            </S.Text></S.Row>
            <ProviderContent 
                key={provider.providerId} 
                providerForm = {PROVIDER[provider.providerId]}
                paymentData={provider}
                userData={user}
                isLogged={isLogged}
                onlyOne = {true}
                form ={'providerContentForm_' + provider.providerId}
            />
            <S.Row><S.Header>
                <S.Button onClick={openAccountModal}>
                    {translation('account_loggedPanel_depositLoginPopup_moreOptions')}
                </S.Button>
            </S.Header></S.Row>
        </S.AccountDeposit>);
     } else {
        return (
            <S.NoActiveProviders>
                {translation('payments_noActiveProviders')}
                <S.Row><S.Header>
                    <S.Button onClick={openAccountModal}>
                        {translation('account_loggedPanel_depositLoginPopup_moreOptions')}
                    </S.Button>
                </S.Header></S.Row>
            </S.NoActiveProviders>
        );
    }
}

export default withRouter(React.memo(DepositLogin));